import {DEFAULT_USER} from "../store/enaeaSlice";
import {CommunistPartySecretaryChats} from "../pages/communistPartySecretary";

export enum ModelType {
    COMMON = 1,
    RESOURCE,
    ASSISTANT,
    PROJECT,
    PARTNER,
    NO_AUTH,
    ASSISTANT_COMMON,
    HEAD_TEACHER,
    //Assistant_New
    POLICY_PAPERS = 9,//政策文件
    IDEOLOGICAL_VALUES,//思想价值
    CAUCUS_CLASSES,//党团班级
    STUDENT_ACADEMICS,//学生就业
    EVERYDAY_MATTERS,//日常事务
    MENTAL_HEALTH,//心理健康
    INTERNET_IDEOLOGY_AND_POLITICS,//网络思政
    CRISIS_EVENTS,//危机事件应对
    EMPLOYMENT_AND_ENTREPRENEURSHIP,//就业创业
    SCIENTIFIC_RESEARCH_CAPABILITIES,//科研能力
    //NewAiHeadTeacher
    ASSISTANT_PARTNER = 19,//智能学伴
    POLICY_NAV,//政策导航
    CAUCUS_JOB,//党务工作
    CAUCUS_JOB_2026,//党务工作
    MORAL_EDUCATION_JOB,//德育工作
    CLASSES_MANAGE,//班级管理
    MENTAL_HEALTH_NEW,//心理健康
    PROFESSIONAL_COMPETENCE,//专业能力
    CUSTOMER_SERVICE_ASSISTANT, //客服助手
    LABOR_EDUCATION,//劳动教育
    //communist_party_secretary
    COMMUNIST_PARTY_SECRETARY,//党组织书记
    ASSISTANT_2026,//党组织书记2026
}

export enum ModelTypeID {
    COMMON = '1912744575558303744',
    ASSISTANT_COMMON = '1921830258054844416',
    RESOURCE = '1912744575558303746',
    ASSISTANT = '1912744575558303745',
    PROJECT = '1912744575558303747',
    PARTNER = '1912744575558303748',
    HEAD_TEACHER = '1921830258054844417',
    ASSISTANT_NEW = '1921830258054844418',
    HEAD_TEACHER_NEW = '1933039843198107651',
    CUSTOMER_SERVICE_ASSISTANT = '1933039843198107652',
    COMMUNIST_PARTY_SECRETARY = '1933039843198107653',
    CAUCUS_JOB_2026 = '2067510031049293825',
    ASSISTANT_2026 = '2067510031049293824',
    DEER_FLOW = '1928055536592842766'
}

export enum AbilityTypeId {
    //ModelType.RESOURCE
    RESOURCE_COURSE = '1912747153025196032',
    RESOURCE_CASE = '1912747153025196033',
    RESOURCE_DIGITAL_RESOURCE = '1912747153025196034',
    RESOURCE_EXPERT = '1912747153025196035',
    //ModelType.PARTNER
    PARTNER_PERSONAL_TRAINING = '1912750568589578241',
    PARTNER_PROJECT = '1912750568589578242',
    PARTNER_COURSE = '1912750568589578243',
    PARTNER_JOB = '1912750568589578244',
}

export type ModelItemType = {
    id: ModelTypeID | ModelType;
    key: ModelTypeID | ModelType;
    message: string;
    type: ModelType;
    modelTypeId?: ModelTypeID;
    authCheck?: boolean;
    class?: string;
}

export interface ChatRequestBody {
    /**
     * 智能体ID
     */
    agent_id: string;
    /**
     * 会话ID，会话ID
     */
    conversation_id?: string;
    /**
     * 深度思考，true是 false否（默认false）
     */
    deep_think?: boolean;
    /**
     * 用户问题
     */
    query: string;
    /**
     * 流式输出，true是 false否（默认true）
     */
    stream?: boolean;
    /**
     * 技能ID
     */
    tool_id?: string;
    /**
     * 用户ID，用户唯一标识
     */
    user_id: string;
    /**
     * 联网搜索，true是 false否（默认false）
     */
    web_search?: boolean;
}

export enum EventType {
    MESSAGE_END = "message_end",
    MESSAGE = 'message',
}

export interface ChatResp {
    "event": EventType,
    "conversation_id": string,
    "message_id": string,
    "created_at": number,
    "task_id": string,
    "id": string,
    "answer": string,
}

export const baseUrl = {
    dev: 'https://study.enaea.edu.cn/enaea',
    test: 'https://study.enaea.edu.cn/enaea',
    prod: 'https://study.enaea.edu.cn/enaea'
    // @ts-ignore
}[process.env.REACT_APP_MODE || 'prod'];
export const URL = {
    getUserInfo: 'https://study.enaea.edu.cn/getCurrentUser.do',
    login: 'https://study.enaea.edu.cn/login.do?fromurl=',
    logout: 'https://passport.enaea.edu.cn/logout.do'
}
export const authCheckRequest = async (): Promise<typeof DEFAULT_USER> => {
    return fetch(URL.getUserInfo).then(res => res.json());
};
